(function () {
  'use strict';
  if (window.loaLib1) return;
  var script = document.currentScript;
  if (!script || !script.getAttribute('data-url')) return;
  function blob(selector) {
    try { return JSON.parse(document.querySelector(selector).textContent) || {}; } catch (e) { return {}; }
  }
  var strings = blob('[data-lb1-strings]');
  if (!Object.keys(strings).length) return;
  var shelves = blob('[data-lb1-shelves]');
  var cfg = {};
  ['url', 'signed', 'member', 'lang', 'root', 'audio', 'texts', 'days', 'start', 'login', 'css', 'lists', 'books'].forEach(function (k) {
    var v = script.getAttribute('data-' + k) || '';
    cfg[k] = ['signed', 'member', 'audio', 'texts'].indexOf(k) >= 0 ? v === '1' : k === 'days' ? Number(v) : v;
  });
  var ICON_RIBBON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lb1-o" d="M7 3.75h10c.69 0 1.25.56 1.25 1.25v15.1c0 .49-.55.77-.95.49L12 16.9l-5.3 3.69c-.4.28-.95 0-.95-.49V5c0-.69.56-1.25 1.25-1.25z"/><path class="lb1-k" d="M9.2 9.7l1.9 1.9 3.7-3.8"/></svg>';
  var ICON_CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_BELL = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 1.5h-15z"/><path d="M10 20.5a2.2 2.2 0 0 0 4 0"/></svg>';
  var selector = '[data-lb1-rib], [data-lb1-save-btn]';
  var kinds = [
    { card: 'a.book', cover: '.cv', title: '.ti' },
    { card: 'li.cc-card', link: 'a.cc-link', cover: '.cv', title: '.ti' },
    { card: 'a.sp-cv', selfCover: true, label: true, position: true },
    { card: 'tr', link: 'td.b a.sp-tcv', cover: 'td.b a.sp-tcv', target: 'td.b', title: 'a.t', row: true },
    { card: 'article.ln17-book', link: 'a.cv', cover: 'a.cv', title: 'a.ti', selfTarget: true, position: true }
  ];
  var cardSelector = kinds.map(function (kind) { return kind.card; }).join(',');
  var controls = [], wired = new WeakSet(), made = new WeakSet();
  var aliases = Object.create(null), states = Object.create(null), asked = new Set(), busy = new Set(), listeners = [];
  var cssLoaded = false, cssScheduled = false, listPromise;
  var toastNode, toastTimer, sheet, scrim, sheetOpener;
  function el(tag, cls, parent, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    if (parent) parent.appendChild(n);
    return n;
  }
  function button(parent, key, attr, fn) {
    var b = el('button', '', parent, say(key));
    b.type = 'button';
    if (attr) b.setAttribute(attr, '');
    if (fn) b.addEventListener('click', fn);
    return b;
  }
  function say(key, values) {
    var v = strings[key];
    if (v && typeof v === 'object') v = v[cfg.audio || (READY && (READY.audio || []).length > 0 && cfg.lang === 'en') ? 'audio_on' : 'audio_off'];
    return String(v == null ? '' : v).replace(/\{(\w+)\}/g, function (_, k) {
      return values && values[k] != null ? String(values[k]) : '';
    });
  }
  function call(method, path, body) {
    var options = { method: method, credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body !== undefined) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(cfg.url.replace(/\/$/, '') + path, options).then(function (r) {
      return r.json().then(function (d) { return { status: r.status, data: d || {} }; },
        function () { return { status: r.status, data: {} }; });
    }, function () { return null; });
  }
  function css() {
    if (cssLoaded || !cfg.css) return;
    cssLoaded = true;
    var l = el('link', '', document.head);
    l.rel = 'stylesheet'; l.href = cfg.css;
  }
  function scheduleCss() {
    if (cssScheduled) return;
    cssScheduled = true;
    if (window.requestIdleCallback) window.requestIdleCallback(css, { timeout: 1000 });
    else setTimeout(css, 600);
  }
  function canonical(k) { return aliases[k] || k; }
  function state(k) { return states[canonical(k)] || null; }
  function saved(status) { return !!status && status !== 'dropped'; }
  function info(b) {
    return { key: b.getAttribute('data-lb1-key'), kind: b.getAttribute('data-lb1-kind') || 'book',
      title: b.getAttribute('data-lb1-title') || '', opener: b };
  }
  /* OPEN-FB-2A (D242 GAP-11): per title, not per shop. The shop-wide flags (data-texts, data-audio) stay the rule; a title is ALSO open when its book-page button says so (data-lb1-tx=1, data-lb1-ax=1: the theme's
     per-title gates) or when it is on the per-set list the boot snippet prints (script data-lb1-ready: sets, forbidden, audio; English pages only). A title the list does not name follows the flags as before. */
  var READY = (function () {
    try { var n = document.querySelector('script[data-lb1-ready]'); return n ? JSON.parse(n.textContent) : null; } catch (e) { return null; }
  })();
  function listed(key, which) {
    var m = READY && cfg.lang === 'en' && (READY.sets || []).indexOf('forbidden-en') >= 0 && /^forbidden-0*(\d+)$/.exec(String(key || ''));
    return !!m && (READY[which] || []).indexOf(Number(m[1])) >= 0;
  }
  function isOpen(o, key, attr, which, flag) {
    var v = o.opener ? o.opener.getAttribute(attr) : null;
    if (v === '1' || listed(key || o.key, which)) return true;
    return v === '0' ? false : flag;
  }
  function eventFor(o, key) {
    if (o.kind === 'summary' || o.key.indexOf('sum:') === 0) return '';
    if (!isOpen(o, key, 'data-lb1-tx', 'forbidden', cfg.texts)) return 'text';
    return isOpen(o, key, 'data-lb1-ax', 'audio', cfg.audio) ? '' : 'audio';
  }
  function renderControl(b) {
    var o = info(b), status = state(o.key), on = saved(status);
    b.setAttribute('aria-pressed', String(on));
    b.setAttribute('aria-label', on ? say('saved_a11y', { title: o.title }) : o.kind === 'summary' ? say('save_summary') + ': ' + o.title : say('save_a11y', { title: o.title }));   /* UX-2 (H7): the name starts with the visible words 'Save summary' */
    var label = b.querySelector('[data-lb1-label]');
    if (label) label.textContent = say(on ? 'saved' : o.kind === 'summary' ? 'save_summary' : 'save');
  }
  function lines() {
    var b = document.querySelector('[data-lb1-save-btn]');
    if (!b) return;
    var o = info(b), status = state(o.key), on = saved(status), ev = eventFor(o);
    var w = document.querySelector('[data-lb1-where]'), bell = document.querySelector('[data-lb1-bell-line]');
    if (w) {
      w.hidden = !on;
      if (on) {
        w.textContent = '';
        var parts = say('in_shelf', { shelf: '{shelf}' }).split('{shelf}');
        w.appendChild(document.createTextNode(parts[0]));
        el('b', '', w, shelves[status] || shelves.want || '');
        w.appendChild(document.createTextNode((parts[1] || '') + ' · '));
        button(w, 'add_list', 'data-lb1-addlist', function (e) { addList(o, e.currentTarget); });
      }
    }
    if (bell) {
      bell.hidden = !on || !ev;
      if (on && ev) {
        bell.textContent = '';
        var span = el('span', 'lb1-bell', bell);
        span.innerHTML = ICON_BELL;
        span.appendChild(document.createTextNode(say(ev === 'text' ? 'toast_soon_line' : 'soon_audio_line')));
      }
    }
  }
  function update(k, status, announce) {
    k = canonical(k);
    states[k] = status || null;
    controls.forEach(function (b) { if (canonical(info(b).key) === k) renderControl(b); });
    lines();
    if (announce) listeners.slice().forEach(function (fn) { fn(k, status || null); });
  }
  function setState(k, status) { update(k, status, true); }
  function closeToast() {
    clearTimeout(toastTimer);
    if (toastNode) toastNode.remove();
    toastNode = null;
  }
  function toast(o) {
    css(); closeToast();
    var t = toastNode = el('div', 'lb1-toast' + (o.error ? ' is-err' : ''), document.body);
    t.setAttribute('role', o.error ? 'alert' : 'status');
    t.innerHTML = ICON_RIBBON;
    var p = el('p', '', t, o.text || '');
    if (o.small) el('small', '', p, o.small);
    var acts = el('div', 'acts', t);
    if (o.list) button(acts, 'add_list', 'data-lb1-addlist', function (e) {
      closeToast();
      if (typeof o.list === 'function') o.list(e.currentTarget);
      else addList(o.list, e.currentTarget);
    });
    if (o.undo) button(acts, 'undo', 'data-lb1-undo', function () {
      closeToast(); if (typeof o.undo === 'function') o.undo();
    });
    if (o.retry) button(acts, 'try_again', 'data-lb1-retry', function () { closeToast(); o.retry(); });
    if (o.error) {
      var x = button(acts, '', 'data-lb1-close', closeToast);
      x.textContent = ''; x.className = 'lb1-tx'; x.setAttribute('aria-label', say('close'));
      x.innerHTML = ICON_CROSS;
    } else toastTimer = setTimeout(closeToast, o.ms == null ? 5000 : o.ms);
    return t;
  }
  function addList(o, fallback) {
    var key = canonical(o.key);
    var opener = controls.find(function (b) { return b.isConnected && canonical(info(b).key) === key; }) || fallback;
    var options = { key: key, kind: o.kind, title: o.title, opener: opener };
    function open() { if (typeof window.loaLib1.openAddToList === 'function') window.loaLib1.openAddToList(options); }
    if (typeof window.loaLib1.openAddToList === 'function') { open(); return; }
    if (!listPromise) listPromise = new Promise(function (resolve) {
      var s = el('script', '', document.body);
      s.onload = resolve; s.onerror = resolve; s.src = cfg.lists;
    });
    listPromise.then(open);
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.remove(); scrim.remove(); sheet = null; scrim = null;
    document.removeEventListener('keydown', sheetKeys);
    if (sheetOpener) sheetOpener.focus();
  }
  function sheetKeys(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab' || !sheet) return;
    var links = sheet.querySelectorAll('a,button');
    var first = links[0], last = links[links.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openGuestSheet(o) {
    if (sheet) return;
    css();
    sheetOpener = o.opener || document.activeElement;
    scrim = el('div', 'lb1-scrim', document.body); scrim.setAttribute('data-lb1-scrim', '');
    scrim.addEventListener('click', closeSheet);
    sheet = el('div', 'lb1-sheet', document.body);
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', say('guest_h')); sheet.setAttribute('data-lb1-sheet', '');
    var box = el('div', 'lb1-gsheet', sheet);
    el('h2', '', box, say('guest_h')); el('p', '', box, say('guest_p'));
    var start = el('a', 'btn btn-gold', box, say('guest_start'));
    var u = new URL(cfg.start, location.href);
    u.searchParams.set('book', o.key); u.searchParams.set('then', 'save');
    start.setAttribute('href', u.pathname + u.search + u.hash); start.setAttribute('data-start', '');
    if (!cfg.signed) {
      var fine = el('p', 'fine', box), text = say('guest_member'), match = /\{([^{}]*)\}/.exec(String(strings.guest_member || ''));
      if (match) {
        var raw = String(strings.guest_member);
        fine.appendChild(document.createTextNode(raw.slice(0, match.index)));
        var a = el('a', '', fine, match[1]);
        var here = new URL(location.href); here.searchParams.set('save', o.key);
        a.setAttribute('href', cfg.login + (cfg.login.indexOf('?') >= 0 ? '&' : '?') + 'return_url=' + encodeURIComponent(here.pathname + here.search));
        fine.appendChild(document.createTextNode(raw.slice(match.index + match[0].length)));
      } else fine.textContent = text;
    }
    document.addEventListener('keydown', sheetKeys); start.focus();
  }
  function action(o, removing, quiet) {
    var k = canonical(o.key);
    if (busy.has(k)) return;
    busy.add(k);
    var old = state(k), b = o.opener;
    if (b) b.classList.remove('is-err');
    update(k, removing ? null : 'want', false);
    var timer = setTimeout(function () { if (b) b.setAttribute('aria-busy', 'true'); }, 300);
    var body = { key: o.key, kind: o.kind, lang: cfg.lang,
      source: o.kind === 'summary' ? 'summary' : b && b.hasAttribute('data-lb1-save-btn') ? 'book' : 'card' };
    call(removing ? 'DELETE' : 'POST', removing ? '/library?key=' + encodeURIComponent(k) : '/library', removing ? undefined : body).then(function (r) {
      clearTimeout(timer); if (b) b.removeAttribute('aria-busy'); busy.delete(k);
      var ok = r && (removing ? r.status >= 200 && r.status < 300 : r.status === 200 || r.status === 201);
      if (!ok) {
        update(k, old, false);
        if (b) {
          b.classList.add('is-err');
          b.setAttribute('aria-label', say('err_a11y', { title: o.title }));
          if (r && r.status === 404 && r.data.error === 'unknown_title' && b.closest(cardSelector) && b.hasAttribute('data-lb1-rib')) b.remove();
        }
        toast({ error: true, text: say('toast_error'), small: say('toast_error_line'), retry: function () { action(o, removing, quiet); } });
        return;
      }
      var it = r.data.item || {}, next = it.key || k;
      if (!removing) {
        Object.keys(aliases).forEach(function (a) { if (aliases[a] === k) aliases[a] = next; });
        aliases[o.key] = next; aliases[k] = next;
      }
      setState(next, removing ? null : it.status || 'want');
      var ev = eventFor(o, next);
      if (ev) {
        if (removing) call('DELETE', '/notify?key=' + encodeURIComponent(next) + '&event=' + encodeURIComponent(ev));
        else call('POST', '/notify', { key: next, event: ev, lang: cfg.lang });
      }
      if (quiet) return;
      toast({ text: say(removing ? 'toast_removed' : ev === 'text' ? 'toast_saved_soon' : 'toast_saved'),
        small: !removing && ev === 'text' ? say('toast_soon_line') : '',
        list: !removing && ev !== 'text' ? function (fallback) { addList(o, fallback); } : false,
        undo: function () { action(o, !removing, true); } });
    });
  }
  function makeCard(a) {
    if (made.has(a) || a.matches('.ghost,.end') || a.closest('header,.hdr16,.mega,[role="dialog"],.drawer,.lb1-list,[data-lb1-skip]')) return;
    var kind = kinds.find(function (k) { return a.matches(k.card); });
    var link = kind.link ? a.querySelector(kind.link) : a;
    var cv = kind.selfCover ? a : kind.card === 'li.cc-card' ? link && link.querySelector(kind.cover) : a.querySelector(kind.cover);
    var m;
    if (!link || !cv) return;
    try { m = /\/products\/([^/]+)\/?$/.exec(new URL(link.getAttribute('href'), location.href).pathname); } catch (e) { return; }
    if (!m) return;
    var target = kind.selfTarget ? a : kind.target ? a.querySelector(kind.target) : cv;
    if (!target || target.closest('[aria-hidden="true"]')) return;
    made.add(a);
    if (a.querySelector('[data-lb1-rib]')) return;
    var titleRoot = kind.row ? target : kind.card === 'li.cc-card' ? link : a;
    var ti = kind.label ? a.closest('li') && a.closest('li').querySelector('a.t') : titleRoot.querySelector(kind.title);
    var img = cv.querySelector('img');
    var title = kind.label ? a.getAttribute('aria-label') || ti && ti.textContent.trim() || m[1] :
      ti && ti.textContent.trim() || img && img.alt || m[1];
    if (kind.position && getComputedStyle(target).position === 'static') target.classList.add('lb1-cvw');
    var b = el('button', 'lb1-rib' + (kind.row ? ' in row' : ''), target);
    b.type = 'button'; b.setAttribute('data-lb1-rib', '');
    b.setAttribute('data-lb1-key', m[1]); b.setAttribute('data-lb1-kind', 'book'); b.setAttribute('data-lb1-title', title);
    b.innerHTML = ICON_RIBBON;
    if (!kind.row) {
      var width = cv.getBoundingClientRect().width;
      if (width > 0 && width <= 120) b.classList.add('sm');
      if (width >= 200) b.classList.add('lg');
    }
  }
  function scan(root) {
    root = root || document;
    var cards = Array.prototype.slice.call(root.querySelectorAll(cardSelector));
    if (root.matches && root.matches(cardSelector)) cards.unshift(root);
    cards.forEach(makeCard);
    var found = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) found.unshift(root);
    var keys = [];
    found.forEach(function (b) {
      if (wired.has(b)) return;
      wired.add(b); controls.push(b); renderControl(b); scheduleCss();
      var k = info(b).key;
      if (cfg.member && k && !asked.has(k)) { asked.add(k); keys.push(k); }
    });
    for (var i = 0; i < keys.length; i += 100) ask(keys.slice(i, i + 100));
  }
  function ask(keys) {
    call('GET', '/library/states?keys=' + encodeURIComponent(keys.join(','))).then(function (r) {
      if (!r || r.status >= 400 || !r.data.states) return;
      var map = r.data.keys || {};
      Object.keys(map).forEach(function (k) { aliases[k] = map[k]; });
      Object.keys(r.data.states).forEach(function (k) { states[k] = r.data.states[k].status || null; });
      controls.forEach(renderControl); lines();
    });
  }
  window.loaLib1 = { cfg: cfg, say: say, call: call, toast: toast, scan: scan, setState: setState, state: state,
    openGuestSheet: openGuestSheet, onChange: function (fn) { listeners.push(fn); } };
  document.dispatchEvent(new CustomEvent('loa-lib1-ready'));
  document.addEventListener('click', function (e) {
    var b = e.target.closest(selector);
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var o = info(b);
    if (!cfg.member) { openGuestSheet(o); return; }
    action(o, saved(state(o.key)), false);
  }, true);
  function init() {
    scan(document);
    var pending;
    new MutationObserver(function (records) {
      if (!records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches(cardSelector + ',' + selector) || n.querySelector(cardSelector + ',' + selector));
        });
      })) return;
      clearTimeout(pending); pending = setTimeout(function () { scan(document); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
    if (cfg.member) {
      var u = new URL(location.href), key = u.searchParams.get('save');
      if (key) {
        u.searchParams.delete('save');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
        var b = key === '1' ? document.querySelector('[data-lb1-save-btn]') : controls.find(function (c) { return info(c).key === key; });
        if (b) action(info(b), false, false);
        else if (key !== '1') action({ key: key, kind: key.indexOf('sum:') === 0 ? 'summary' : 'book', title: '', opener: null }, false, false);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
